var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.isReadOnly
      ? _c(
          "div",
          [
            _c(
              "b-sidebar",
              {
                ref: "layoutSidebar",
                staticClass: "prevent-unselect layout-sidebar",
                attrs: {
                  "bg-variant": "white",
                  "header-class": "border-bottom p-3 mb-2",
                  shadow: "",
                  "z-index": "1040",
                  title: _vm.htmlTemplateName,
                  "footer-class": ["px-3 py-2"],
                  width: _vm.width,
                  right: _vm.right,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("toggle")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "layout-sidebar-footer",
                              class: {
                                "layout-sidebar-footer--ai-active":
                                  _vm.tabIndex === _vm.designAiTabIndex,
                              },
                            },
                            [
                              _vm.selectedInstance
                                ? _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "layout-sidebar-footer-nav nav nav-pills flex-column",
                                      attrs: { role: "tablist" },
                                    },
                                    [
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "nav-item layout-sidebar-clipboard-tab",
                                          attrs: { role: "presentation" },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "nav-link",
                                              class: _vm.clipboardNavLinkClass,
                                              attrs: {
                                                href: "#",
                                                role: "button",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.onFooterClipboardClick.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "TabTitle",
                                                {
                                                  attrs: { title: "Clipboard" },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "sidebar-custom-icon",
                                                    },
                                                    [
                                                      _c("use", {
                                                        attrs: {
                                                          width: "17.5",
                                                          height: "17.5",
                                                          href: "/img/icons/clipboard.svg#icon-clipboard",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "nav-item layout-sidebar-ai-tab",
                                          attrs: { role: "presentation" },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "nav-link",
                                              class: {
                                                active:
                                                  _vm.tabIndex ===
                                                  _vm.designAiTabIndex,
                                              },
                                              attrs: {
                                                href: "#",
                                                role: "button",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.goToAiChatTab.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "TabTitle",
                                                {
                                                  attrs: { title: "Optix AI" },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "sidebar-custom-icon",
                                                    },
                                                    [
                                                      _c("use", {
                                                        attrs: {
                                                          width: "17.5",
                                                          height: "17.5",
                                                          href: "/img/icons/sparkles.svg#icon-sparkles",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.tabIndex !== _vm.designAiTabIndex
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "layout-sidebar-footer-meta",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.fieldType ===
                                                "Multi Line Text"
                                                ? "Text"
                                                : _vm.fieldType
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3800921461
                ),
                model: {
                  value: _vm.visible,
                  callback: function ($$v) {
                    _vm.visible = $$v
                  },
                  expression: "visible",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "layout-sidebar__shell" },
                  [
                    _vm.selectedInstance
                      ? _c(
                          "b-tabs",
                          {
                            staticClass:
                              "no-gutters h-100 layout-sidebar__tabs",
                            attrs: {
                              "nav-wrapper-class": "layout-sidebar-nav-wrapper",
                              "content-class": _vm.sidebarContentClass,
                              small: "",
                              pills: "",
                              vertical: "",
                              end: "",
                              "nav-class": _vm.target ? "" : "no-target",
                            },
                            on: { input: _vm.onSidebarTabInput },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "tabs-end",
                                  fn: function () {
                                    return [
                                      _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              value: `${
                                                _vm.right ? "Left" : "Right"
                                              } side`,
                                              expression:
                                                "`${right ? 'Left' : 'Right'} side`",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          staticClass:
                                            "my-auto ml-auto mr-1 d-none",
                                          attrs: {
                                            variant: "primary",
                                            size: "sm",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.right = !_vm.right
                                            },
                                          },
                                        },
                                        [
                                          _c("b-icon", {
                                            attrs: {
                                              icon: `arrow-bar-${
                                                _vm.right ? "left" : "right"
                                              }`,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2941356894
                            ),
                            model: {
                              value: _vm.tabIndex,
                              callback: function ($$v) {
                                _vm.tabIndex = $$v
                              },
                              expression: "tabIndex",
                            },
                          },
                          [
                            _c(
                              "b-tab",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("TabTitle", {
                                            attrs: {
                                              title: "Settings",
                                              icon: "sliders",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1875473405
                                ),
                              },
                              [
                                _vm._v(" "),
                                _vm.target
                                  ? [
                                      _c(
                                        "b-link",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName:
                                                "v-b-tooltip.hover.left.viewport.noninteractive",
                                              value: `Go to layer`,
                                              expression: "`Go to layer`",
                                              modifiers: {
                                                hover: true,
                                                left: true,
                                                viewport: true,
                                                noninteractive: true,
                                              },
                                            },
                                          ],
                                          staticClass:
                                            "layer-name-link d-inline-block",
                                          on: { click: _vm.goToLayersTab },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.layerName) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isElementRestricted
                                        ? _c(
                                            "b-alert",
                                            {
                                              staticClass:
                                                "mb-2 py-2 px-3 small",
                                              attrs: {
                                                show: "",
                                                variant: "info",
                                              },
                                            },
                                            [
                                              _c("b-icon", {
                                                staticClass: "mr-1",
                                                attrs: { icon: "info-circle" },
                                              }),
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.elementRestrictions
                                                      .reason
                                                  ) +
                                                  "\n              "
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.typeEditorControl === "TEXT"
                                        ? _c("TextEditorControl", {
                                            key: _vm.t,
                                            ref: "textEditorControl",
                                            attrs: {
                                              id: "text-editor-control-settings",
                                              target: _vm.target,
                                              options: _vm.options,
                                              themes: _vm.themes,
                                              "field-type": _vm.fieldType,
                                              "is-open": _vm.isOpen,
                                            },
                                            on: {
                                              toggleSection: _vm.toggleSection,
                                            },
                                          })
                                        : _vm.typeEditorControl === "SHAPE"
                                        ? _c("ShapeEditorControl", {
                                            attrs: {
                                              target: _vm.target,
                                              themes: _vm.themes,
                                              "is-open": _vm.isOpen,
                                            },
                                            on: {
                                              toggleSection: _vm.toggleSection,
                                            },
                                          })
                                        : _vm.typeEditorControl === "IMAGE"
                                        ? _c("ImageEditorControl", {
                                            attrs: {
                                              target: _vm.target,
                                              options: _vm.options,
                                              themes: _vm.themes,
                                              "is-tab-active":
                                                _vm.tabIndex ===
                                                _vm.TAB_INDEX.SETTINGS,
                                              "is-open": _vm.isOpen,
                                            },
                                            on: {
                                              toggleSection: _vm.toggleSection,
                                              toggle: function ($event) {
                                                return _vm.$emit("toggle")
                                              },
                                            },
                                          })
                                        : _vm.typeEditorControl ===
                                          "PRODUCT_DIMENSION"
                                        ? _c("ProductDimensionEditorControl", {
                                            attrs: {
                                              options: _vm.options,
                                              "is-open": _vm.isOpen,
                                              target: _vm.target,
                                            },
                                            on: {
                                              toggleSection: _vm.toggleSection,
                                              toggle: function ($event) {
                                                return _vm.$emit("toggle")
                                              },
                                            },
                                          })
                                        : _vm.typeEditorControl === "GROUP"
                                        ? _c("GroupEditorControl", {
                                            attrs: {
                                              themes: _vm.themes,
                                              options: _vm.options,
                                              target: _vm.target,
                                              "is-open": _vm.isOpen,
                                            },
                                            on: {
                                              toggleSection: _vm.toggleSection,
                                              unselected: function ($event) {
                                                return _vm.switchToTab(
                                                  _vm.TAB_INDEX.EFFECTS
                                                )
                                              },
                                            },
                                          })
                                        : _vm.typeEditorControl ===
                                          "SMART_OBJECT"
                                        ? _c("SmartObjectEditorControl", {
                                            attrs: {
                                              options: _vm.options,
                                              preview: _vm.target.preview,
                                              "smart-objects-list":
                                                _vm.target.smartObjectsList,
                                              target: _vm.target,
                                              "smart-object-id":
                                                _vm.target?.smartObjectId,
                                              "is-open": _vm.isOpen,
                                            },
                                            on: {
                                              toggleSection: _vm.toggleSection,
                                              "focus-textarea":
                                                _vm.focusTextarea,
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("TabTitle", {
                                            attrs: {
                                              title: "Properties",
                                              icon: "gear-wide-connected",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  382685246
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("PropertiesModule", {
                                  attrs: {
                                    target: _vm.target,
                                    options: _vm.modules.properties,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  "title-item-class": "instance-related",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("TabTitle", {
                                            attrs: {
                                              title: "Layers",
                                              icon: "layers",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  278230574
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("LayersModule", {
                                  ref: "layersModule",
                                  attrs: {
                                    "is-tab-active":
                                      _vm.tabIndex === _vm.TAB_INDEX.LAYERS,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  "title-item-class": "instance-related",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("TabTitle", {
                                            attrs: {
                                              title: "Content",
                                              icon: "images",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  318483027
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("ContentModule", {
                                  attrs: { "switch-to-tab": _vm.switchToTab },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("TabTitle", {
                                            attrs: {
                                              title: "Shadows",
                                              icon: "back",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3128943184
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("ShadowsModule", {
                                  attrs: { target: _vm.target },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  "title-item-class": "instance-related",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("TabTitle", {
                                            attrs: {
                                              title: "Translate",
                                              icon: "translate",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  736254926
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("TranslateModule", {
                                  attrs: {
                                    "is-open": _vm.isOpen,
                                    target: _vm.backgroundColorRectangle,
                                    options: _vm.options,
                                  },
                                  on: {
                                    unselected: _vm.goToFieldsTab,
                                    toggleSection: _vm.toggleSection,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  "title-item-class": {
                                    "d-none": _vm.typeEditorControl !== "TEXT",
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("TabTitle", {
                                            attrs: {
                                              title: "Gradient Fill",
                                              icon: "paint-bucket",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1337269798
                                ),
                              },
                              [
                                _vm._v(" "),
                                _vm.target
                                  ? _c("TextColorEditor", {
                                      attrs: {
                                        height: _vm.target?.height || 100,
                                        target: _vm.target,
                                        width: _vm.target?.width || 200,
                                      },
                                      on: {
                                        gradientApplied: _vm.applyTextGradient,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  "title-item-class": {
                                    "d-none": _vm.typeEditorControl !== "TEXT",
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("TabTitle", {
                                            attrs: {
                                              title: "Effects",
                                              icon: "brush",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1201080020
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("EffectsModule", {
                                  attrs: { target: _vm.target },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("TabTitle", {
                                            attrs: {
                                              title: "Animations",
                                              icon: "collection-play",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2598209684
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("AnimationsModule", {
                                  attrs: {
                                    target: _vm.target,
                                    options: _vm.modules.animation,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  "title-item-class": "instance-related",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("TabTitle", {
                                            attrs: {
                                              title: "Fields",
                                              icon: "diagram3",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3907081081
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("FieldsModule", {
                                  attrs: {
                                    "is-open": _vm.isOpen,
                                    target: _vm.backgroundColorRectangle,
                                    options: _vm.options,
                                    "type-editor-control":
                                      _vm.typeEditorControl,
                                  },
                                  on: {
                                    unselected: _vm.goToFieldsTab,
                                    toggleSection: _vm.toggleSection,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.backgroundColorRectangle,
                                    expression: "backgroundColorRectangle",
                                  },
                                ],
                                attrs: {
                                  "title-item-class": "instance-related",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c(
                                            "TabTitle",
                                            {
                                              attrs: {
                                                title:
                                                  "Background Color Editor",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-iconstack",
                                                {
                                                  staticClass:
                                                    "overflow-hidden",
                                                },
                                                [
                                                  _c("b-icon", {
                                                    attrs: {
                                                      stacked: "",
                                                      icon: "square",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("b-icon", {
                                                    attrs: {
                                                      stacked: "",
                                                      scale: "1.5",
                                                      rotate: "-45",
                                                      icon: "justify",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2509172747
                                ),
                              },
                              [
                                _vm._v(" "),
                                _vm.backgroundColorRectangle
                                  ? _c("BackgroundColorEditor", {
                                      attrs: {
                                        height:
                                          _vm.backgroundColorRectangle
                                            ?.height || 0,
                                        target: _vm.backgroundColorRectangle,
                                        width:
                                          _vm.backgroundColorRectangle?.width ||
                                          0,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  "title-item-class": "instance-related",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("TabTitle", {
                                            attrs: {
                                              title: "Theme",
                                              icon: "palette",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3370135106
                                ),
                              },
                              [_vm._v(" "), _c("ThemeModule")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.layoutId,
                                    expression: "layoutId",
                                  },
                                ],
                                attrs: {
                                  "title-item-class": "instance-related",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c(
                                            "TabTitle",
                                            {
                                              attrs: {
                                                title: "Comments",
                                                icon: "chat-left-text",
                                              },
                                            },
                                            [
                                              _vm.unresolvedCommentsCount > 0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "badge badge-danger ml-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm.unresolvedCommentsCount
                                                          ) +
                                                          "\n                "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1494503550
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("CommentsPanel", {
                                  attrs: {
                                    "layout-id": _vm.layoutId,
                                    "is-tab-active":
                                      _vm.tabIndex === _vm.TAB_INDEX.COMMENTS,
                                  },
                                  on: {
                                    "comments-updated": _vm.updateCommentsCount,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.layoutId,
                                    expression: "layoutId",
                                  },
                                ],
                                attrs: {
                                  "title-item-class":
                                    "instance-related layout-sidebar-brief-tab",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c(
                                            "TabTitle",
                                            { attrs: { title: "Brief" } },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  staticClass:
                                                    "sidebar-custom-icon",
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-width": "1.5",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "aria-hidden": "true",
                                                  },
                                                },
                                                [
                                                  _c("rect", {
                                                    attrs: {
                                                      width: "8",
                                                      height: "4",
                                                      x: "8",
                                                      y: "2",
                                                      rx: "1",
                                                      ry: "1",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: { d: "M12 11h4" },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: { d: "M12 16h4" },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: { d: "M8 11h.01" },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: { d: "M8 16h.01" },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  970511224
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("BriefPanel", {
                                  key:
                                    _vm.linkedBrief && _vm.linkedBrief.id
                                      ? _vm.linkedBrief.id
                                      : "no-brief",
                                  attrs: {
                                    "layout-id": _vm.layoutId,
                                    "customer-id": _vm.customerId,
                                    "initial-linked-brief": _vm.linkedBrief,
                                  },
                                  on: { updated: _vm.updateLinkedBrief },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  "title-item-class": "instance-related",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("TabTitle", {
                                            attrs: {
                                              title: "Screen Recording",
                                              icon: "display",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1949443061
                                ),
                              },
                              [_vm._v(" "), _c("VideoScreenRecording")],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-tab", {
                              attrs: {
                                "title-item-class":
                                  "instance-related layout-sidebar-clipboard-tab",
                                "title-link-class": _vm.clipboardNavLinkClass,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _c(
                                          "TabTitle",
                                          { attrs: { title: "Clipboard" } },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticClass:
                                                  "sidebar-custom-icon",
                                              },
                                              [
                                                _c("use", {
                                                  attrs: {
                                                    width: "17.5",
                                                    height: "17.5",
                                                    href: "/img/icons/clipboard.svg#icon-clipboard",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2043375739
                              ),
                            }),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  "title-item-class":
                                    "instance-related layout-sidebar-ai-tab",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c(
                                            "TabTitle",
                                            { attrs: { title: "Optix AI" } },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  staticClass:
                                                    "sidebar-custom-icon",
                                                },
                                                [
                                                  _c("use", {
                                                    attrs: {
                                                      width: "17.5",
                                                      height: "17.5",
                                                      href: "/img/icons/sparkles.svg#icon-sparkles",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  22843237
                                ),
                              },
                              [
                                _vm._v(" "),
                                !_vm.target ||
                                (_vm.target &&
                                  _vm.target.type !== "SMART_OBJECT")
                                  ? _c("AIChatModule", {
                                      ref: "aiChatModule",
                                      attrs: {
                                        "is-tab-active":
                                          _vm.tabIndex === _vm.designAiTabIndex,
                                        "target-element": _vm.target,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _vm.visible
              ? _c("ClipboardDrawer", {
                  attrs: {
                    "sidebar-overlay": "",
                    "portal-to-body": "",
                    "sidebar-on-right": _vm.right,
                    "overlay-width": _vm.width,
                    "anchor-rect": _vm.clipboardAnchorRect,
                    "insert-only": "",
                    "draft-text": _vm.layoutClipboardDraftText,
                  },
                  on: { select: _vm.onClipboardInsert },
                  model: {
                    value: _vm.showClipboard,
                    callback: function ($$v) {
                      _vm.showClipboard = $$v
                    },
                    expression: "showClipboard",
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }